import { getEverLoggedIn, getBuyerId } from 'dibs-cookie-jar';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import {
    LOGIN,
    REGISTER,
    DEFAULT_FLOW,
} from 'dibs-buyer-layout/src/authModal/authentication/authFlowConstants';

export function storefrontEnsureLogin({ relayEnvironment, authOptions = {} }) {
    const userId = getBuyerId(document.cookie);
    if (userId) {
        return Promise.resolve({ userId });
    }
    return authModalLoader
        .show({
            flow: DEFAULT_FLOW,
            action: getEverLoggedIn(document.cookie) ? LOGIN : REGISTER,
            relayEnvironment,
            ...authOptions,
        })
        .then(res => {
            if (res.err) {
                throw res.err;
            }
            return { userId: res.userId };
        });
}
